var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"kai-form-field"},[_c('div',[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('kai-form-errors',{staticClass:"mt-4",attrs:{"errors":_vm.fieldErrors,"data-test":(_vm.name + "-field-errors")}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }